
















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
    name: 'card-interruption-time-average',
})
export default class CardInterruptionTimeAverage extends Vue {
    @Prop({ required: true })
    dataCenter!: string;

    @Prop({ required: true })
    timeAverage!: number;

    @Prop({ required: true })
    timeDifference!: number;

    timeAverageText: string = `${this.timeAverage} minutos`;
    titleColor: string = '#464855';

    getTimeDifference(): string {
        const timePlural: string = Math.abs(this.timeDifference) > 1 ? 's' : '';
        const quantifier: string = this.timeDifference > 0 ? 'más' : 'menos';

        const msg: string = `${Math.abs(
            this.timeDifference,
        )} minuto${timePlural} ${quantifier} que el mes anterior`;

        return this.timeDifference === 0 ? 'Igual al mes anterior' : msg;
    }
}
